// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useSnackbar } from 'notistack';
import React from 'react';
import { Box, Card, Switch, Typography } from '@mui/material';
import { useLocalStorage } from '../../contexts/LocalStorageContext';

export const ActiveContractsDisableLogs: React.FC = () => {
  const { localStorageState, setLocalStorageState } = useLocalStorage();
  const { enqueueSnackbar } = useSnackbar();

  const onToggle = () => {
    setLocalStorageState(
      'activeContractsLogsEnabled',
      `${!localStorageState?.activeContractsLogsEnabled}`,
    );
    enqueueSnackbar(
      `Active Contract Logs ${!localStorageState?.activeContractsLogsEnabled ? 'enabled' : 'disabled'}`,
    );
  };
  const { activeContractsLogsEnabled } = localStorageState;
  return (
    <Card
      sx={{ mb: 1, width: '50%', p: 1, display: 'flex', alignItems: 'center' }}
      variant="outlined"
    >
      <Box>
        <Typography fontWeight="bold">Active Contracts Logs</Typography>
        <Typography variant="body2">
          Toggle to enable or disable logging utility of Active Contracts. Disabling logs may reduce
          space impact but will limit debugging capabilities.
        </Typography>
      </Box>
      <Switch sx={{ ml: 'auto' }} checked={activeContractsLogsEnabled} onChange={onToggle} />
    </Card>
  );
};
